export default function ShippingSection() {
  return (
    <section className="py-6 sm:py-8 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="glass-panel rounded-lg sm:rounded-xl p-4 sm:p-6 grid-border">

          {/* Compact Shipping Bar with Icons */}
          <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-8">

            {/* Standard UK Delivery */}
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                </svg>
              </div>
              <div>
                <div className="mono-data text-xs uppercase tracking-wider text-foreground font-bold">
                  7-10 Working Days tracked delivery
                </div>
                <div className="text-xs text-foreground/60">
                  Standard UK Delivery
                </div>
              </div>
            </div>

            {/* Tracked Delivery */}
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
              </div>
              <div>
                <div className="mono-data text-xs uppercase tracking-wider text-foreground font-bold">
                  Fully Tracked
                </div>
                <div className="text-xs text-foreground/60">
                  Real-time updates
                </div>
              </div>
            </div>

            {/* Free Shipping */}
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <div className="mono-data text-xs uppercase tracking-wider text-foreground font-bold">
                  Free UK Shipping
                </div>
                <div className="text-xs text-foreground/60">
                  No hidden fees
                </div>
              </div>
            </div>

          </div>

          {/* Additional Info */}
          <div className="text-center pt-3 sm:pt-4 mt-3 sm:mt-4 border-t border-border/30">
            <p className="mono-data text-xs text-foreground/50">
              30-day returns • Secure Stripe payments • Questions? hello@lume001.online
            </p>
          </div>

        </div>
      </div>
    </section>
  )
}